import { VNodeChildrenArrayContents, h } from 'vue';

export const level = (
  left: VNodeChildrenArrayContents = [],
  right: VNodeChildrenArrayContents = [],
) => h('div', { class: 'level level--page-header' }, [
  h('div', { class: 'level-left' }, left.filter(node => node !== null)),
  h('div', { class: 'level-right' }, right.filter(node => node !== null)),
]);
